var map = {
	"./art.png": 4924,
	"./drink.png": 2869,
	"./eat.png": 6613,
	"./hike.png": 8062,
	"./map_icon.png": 6733,
	"./shop.png": 7711,
	"./ski.png": 1916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2984;